import { render, staticRenderFns } from "./teamChangeBlock.vue?vue&type=template&id=0774a14b&scoped=true&"
import script from "./teamChangeBlock.vue?vue&type=script&lang=js&"
export * from "./teamChangeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0774a14b",
  null
  
)

export default component.exports